module.exports = __webpack_public_path__ + "static/media/shape_black-small.51ce33fd.svg";